import { IAppState } from '../../../../../AppModulesWrapper';
import { IDuration } from '../types';

export function selectTermsDurations(state: IAppState): IDuration[] {
  return state.servicePickerWidgetV2.promotion.duration.durations;
}
